/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q5Inputs */

const en_fw_faq_q5 = /** @type {(inputs: Fw_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a Firefly Wedding live-action drama?`)
};

const zh_fw_faq_q5 = /** @type {(inputs: Fw_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁有真人剧吗？`)
};

/**
* | output |
* | --- |
* | "Is there a Firefly Wedding live-action drama?" |
*
* @param {Fw_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q5 = /** @type {((inputs?: Fw_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q5(inputs)
	return zh_fw_faq_q5(inputs)
});
export { fw_faq_q5 as "fw.faq.q5" }